import { pxToEm } from 'util/pxToEm';
import React, { ReactElement } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useProfile } from 'hooks';

type TabValue = 'setup' | 'calendar-settings' | 'approval';

interface EventSetupTabsProps {
  activeTab: TabValue;
  onTabChange: (tab: TabValue) => void;
}

export const EventSetupTabs = ({
  activeTab,
  onTabChange,
}: EventSetupTabsProps): ReactElement => {
  const theme = useTheme();
  const { profile } = useProfile();

  return (
    <Box mb={16}>
      <Box
        display="inline-flex"
        gap={32}
        borderBottom="1px solid"
        borderColor={theme.palette.neutral.dark}
        width={{ xs: '100%', sm: 'auto' }}
      >
        <Box
          onClick={() => onTabChange('setup')}
          sx={{
            pl: 0,
            pr: 8,
            cursor: 'pointer',
            borderBottom:
              activeTab === 'setup' ? '1px solid' : '2px solid transparent',
            borderColor:
              activeTab === 'setup' ? 'primary.main' : 'transparent',
            transition: 'all 0.2s',
            flex: { xs: 1, sm: 'none' },
          }}
        >
          <Typography
            fontWeight={activeTab === 'setup' ? 500 : 400}
            fontSize={{ xs: pxToEm(14), sm: pxToEm(16) }}
            color={activeTab === 'setup' ? 'primary.main' : 'text.secondary'}
          >
            Setup & Services
          </Typography>
        </Box>

        <Box
          onClick={() => onTabChange('calendar-settings')}
          sx={{
            px: { xs: 6, sm: 8 },
            cursor: 'pointer',
            borderBottom:
              activeTab === 'calendar-settings'
                ? '1px solid'
                : '2px solid transparent',
            borderColor:
              activeTab === 'calendar-settings' ? 'primary.main' : 'transparent',
            transition: 'all 0.2s',
            flex: { xs: 1, sm: 'none' },
            textAlign: { xs: 'center', sm: 'left' },
          }}
        >
          <Typography
            fontWeight={activeTab === 'calendar-settings' ? 500 : 400}
            fontSize={{ xs: pxToEm(14), sm: pxToEm(16) }}
            color={
              activeTab === 'calendar-settings' ? 'primary.main' : 'text.secondary'
            }
          >
            Calendar Settings
          </Typography>
        </Box>

        {profile?.school?.isSequentialApprovalEnabled && (
          <Box
            onClick={() => onTabChange('approval')}
            sx={{
              px: { xs: 6, sm: 8 },
              cursor: 'pointer',
              borderBottom:
                activeTab === 'approval'
                  ? '1px solid'
                  : '2px solid transparent',
              borderColor:
                activeTab === 'approval' ? 'primary.main' : 'transparent',
              transition: 'all 0.2s',
              flex: { xs: 1, sm: 'none' },
              textAlign: { xs: 'center', sm: 'left' },
            }}
          >
            <Typography
              fontWeight={activeTab === 'approval' ? 500 : 400}
              fontSize={{ xs: pxToEm(14), sm: pxToEm(16) }}
              color={
                activeTab === 'approval' ? 'primary.main' : 'text.secondary'
              }
            >
              Approval Workflow
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

